import { exportActions } from '../../services';

export const exportReducer = ( state = {}, action ) => {
  switch ( action.type ) {
    case exportActions.LOAD:
      return action.data.reduce( ( current, item ) => {
        current[item.Key] = false;
        return current; 
      }, {} );  
    case exportActions.SELECT:
      return {...state, [action.exportType]: !state[action.exportType] };
    default:
      return state;
  }
};
